import { useDispatch, useSelector } from "react-redux";
import useToast from "./useToast";
import {
  fetchWorkspaces as fetchWorkspacesThunk,
  forgot as forgotThunk,
  isLoggedIn as isLoggedInThunk,
  login as loginThunk,
  loginWorkspace as loginWorkspaceThunk,
  restorePassword
} from "_config/store/account/account.thunk";
import { WEB_APP } from "_config/constants/app.constants";
import { Icon } from "components/atoms";
import { setCreatePassword, setForgot } from "_config/store/account/slices";

const useAuth = () => {
  const dispatch = useDispatch();
  const {
    data: user,
    error: userError,
    isLoading: userIsLoading
  } = useSelector((s) => s?.account?.owner);

  const {
    data: forgotData,
    error: forgotError,
    isLoading: forgotIsLoading
  } = useSelector((s) => s?.account?.forgot);

  const {
    data: createPasswordData,
    error: createPasswordError,
    isLoading: createPasswordIsLoading
  } = useSelector((s) => s?.account?.createPassword);

  const {
    data: workspaces,
    error: workspacesError,
    isLoading: workspacesIsLoading
  } = useSelector((s) => s?.account?.workspaces);

  const { toast } = useToast();

  const forgot = (post, extras = {}) => dispatch(forgotThunk(post, {
    feeback: {
      error: true
    },
    ...extras,
  })).then((r) => {
    if (r?.data) {
      toast("Recibirás un correo", "success", {
        icon: <Icon icon="check" style={{color: "green"}}/>
      });
    } else if (r?.error && !!extras?.error !== false){
      toast(typeof extras.error === "string" ? extras.error : "Error");
    }
  });
  
  const forgotReset = () => dispatch(setForgot({ data: null }));

  const goToAccount = async ({ token }) => {
    try {
      let { data } = await loginWithToken(token);
      if (data) window.location.replace(WEB_APP);
    } catch(e) {}
  };

  const fetchWorkspaces = (workspacesId, extras = {}) =>
    dispatch(fetchWorkspacesThunk(workspacesId, extras));

  const isLoggedIn = () => dispatch(isLoggedInThunk());

  const login = (data) => dispatch(loginThunk(data)).then(({ error }) => {
    if (error?.status?.[0]?.code === 201) {
      toast("Usuario o contraseña incorrectos", "warning", {
        icon: <Icon icon="closeCircle" style={{color: "orange"}}/>
      });
    }
  });

  const loginWorkspace = (workspaceId, extras = {}) =>
    dispatch(loginWorkspaceThunk(workspaceId, extras));

  const loginWithToken = (token) =>  dispatch(loginThunk(
    null, {
      endpoint: "/auth/login/token",
      headers: {
        "Token-Nubesk": token
      }
    }
  ));

  const createPassword = (token, post, extras = {}) => 
    dispatch(restorePassword(token, post, {
      feedback: { error: true },
      ...extras
    })).then((r) => {
      if (r?.data) {
        toast("Nueva contraseña establecida con éxito", "success", {
          icon: <Icon icon="check" style={{ color: "green" }}/>
        });
      }
    });

  const createPasswordReset = () => dispatch(setCreatePassword())

  return {
    forgot,
    forgotData,
    forgotError,
    forgotIsLoading,
    forgotReset,
    goToAccount,
    isLoggedIn,
    login,
    loginWithToken,
    loginWorkspace,
    createPassword,
    createPasswordData,
    createPasswordError,
    createPasswordIsLoading,
    createPasswordReset,
    fetchWorkspaces,
    workspaces,
    workspacesError,
    workspacesIsLoading,
    user,
    userError,
    userIsLoading
  };
};

export default useAuth;
